// src/components/co-ownership/CoOwnershipHero.tsx
import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import {Button} from '@dopomogai/ui';
import { ImpactGridVisual } from '../../visuals/ImpactGridVisual'; // <-- USE THE CORRECT VISUAL
import { ArrowDown, BookOpen } from 'lucide-react';

interface CoOwnershipHeroProps {
  onAction: (actionType: string, payload?: any) => void;
}

interface HeroData {
  headline: string;
  subheadline: string;
  ctaExplore: string;
  ctaWhitepaper: string;
}

export const CoOwnershipHero: React.FC<CoOwnershipHeroProps> = ({ onAction }) => {
  const { t } = useTranslation('co_ownership');
  const heroData = t('hero', { returnObjects: true }) as HeroData;

  const scrollToShowcase = () => {
    const element = document.getElementById('co-ownership-showcase');
    element?.scrollIntoView({ behavior: 'smooth' });
  };
  
  return (
    <section className="relative bg-gray-900 text-white min-h-[90vh] md:min-h-[80vh] flex items-center py-24 md:py-32 overflow-hidden">
      <motion.div
        className="absolute inset-0"
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.1, transition: { duration: 2, ease: "easeInOut" } }}
      >
        <ImpactGridVisual /> {/* <-- SWAPPED THE COMPONENT HERE */}
      </motion.div>
      
      <div className="container mx-auto px-4 text-center relative z-10">
        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.7, ease: 'easeOut', delay: 0.3 }} 
          className="flex flex-col items-center"
        >
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight drop-shadow-lg">
            {heroData.headline}
          </h1>
          <p className="mt-6 max-w-3xl mx-auto text-lg md:text-xl text-slate-300">
            {heroData.subheadline}
          </p>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              text={heroData.ctaExplore}
              variant="primary"
              size="lg"
              icon={<ArrowDown size={18} />}
              onClick={scrollToShowcase}
              className="w-full sm:w-auto hover:shadow-[4px_4px_0_0_#10b981]"
            />
            <Button
              text={heroData.ctaWhitepaper}
              variant="secondary"
              size="lg"
              icon={<BookOpen size={18} />}
              onClick={() => onAction('OPEN_URL', { url: '/whitepaper.pdf', newTab: true })}
              className="w-full sm:w-auto bg-slate-700 text-white hover:bg-slate-600 hover:shadow-[4px_4px_0_0_#9ca3af]"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};